/* ── Admin Minio API (ES Module) ── */
import { authHeaders } from './admin-auth.js';

export async function fetchMinioAllTags() {
  try {
    const res = await fetch('/minio/tags/all', { headers: authHeaders() });
    return res.ok ? await res.json() : {};
  } catch(e) { return {}; }
}

export async function fetchMinioBrowse(prefix) {
  const res = await fetch(`/minio/browse?prefix=${encodeURIComponent(prefix)}`, { headers: authHeaders() });
  if (!res.ok) throw new Error(await res.text());
  return await res.json();
}

export async function fetchMinioSearch(q) {
  const res = await fetch(`/minio/search?q=${encodeURIComponent(q)}`, { headers: authHeaders() });
  if (!res.ok) throw new Error(await res.text());
  return await res.json();
}

export async function saveMinioTags(file, rawTags) {
  const res = await fetch('/minio/tags', {
    method: 'POST',
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify({
      path: file.path, name: file.name, url: file.url,
      size: file.size || 0, ext: file.ext || '', tags: rawTags
    })
  });
  if (!res.ok) throw new Error(await res.text());
  return await res.json();
}

export async function fetchMinioByTags(tagsStr) {
  const res = await fetch(`/minio/files-by-tags?tags=${encodeURIComponent(tagsStr)}`, { headers: authHeaders() });
  if (!res.ok) throw new Error(await res.text());
  return await res.json();
}

export async function uploadMinioFile(file, prefix) {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('prefix', prefix);
  const token = localStorage.getItem('raptv_token');
  const headers = {};
  if (token) headers['Authorization'] = 'Bearer ' + token;
  const res = await fetch('/minio/upload', { method: 'POST', headers, body: fd });
  if (!res.ok) throw new Error(await res.text());
  return await res.json();
}

export async function importMinioUrl(url, prefix) {
  const res = await fetch('/minio/import-url', {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ url, prefix })
  });
  if (!res.ok) throw new Error(await res.text());
  return await res.json();
}
